<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <EditEvent />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import EditEvent from "./components/EditEvent";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    EditEvent,
    // ProjectsTable,
  },
};
</script>
